module.exports = __webpack_public_path__ + "img/toplupe-logo-about.4d4d190.png";